import { useEffect, useState } from 'react';
import { forceAssert } from '../../common-functions';
import type { JsonData } from '../../generic-types';
import { iconMap } from '../../navigation/icon-mapper';
import type { IconItem, IconSelectorFieldProps } from './icon-selector-field.props';
import { IconSelector } from './icon-selector.component';

const IconSelectorField = ({
  id,
  name,
  label,
  value,
  data,
  valueField = 'icon',
  textField = 'iconFileName',
  readOnly,
  disabled,
  required,
  error,
  onChange,
  className,
}: IconSelectorFieldProps) => {
  const [icons, setIcons] = useState<JsonData>();

  useEffect(() => {
    if (!data) {
      const iconItems: Array<IconItem> = [];
      const iconKeys = Object.keys(iconMap);

      for (let i = 0, length = iconKeys.length; i < length; i++) {
        iconItems.push({
          icon: iconKeys[i],
          iconFileName: iconMap[iconKeys[i]],
        });
      }

      setIcons(forceAssert<JsonData>(iconItems));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Mount-only effect to initialize default icons if no data provided
  }, []);

  return data || icons ? (
    <IconSelector
      id={id}
      name={name}
      label={label}
      value={value}
      data={data || icons}
      textField={textField}
      valueField={valueField}
      readOnly={readOnly}
      disabled={disabled}
      required={required}
      error={error}
      onChange={onChange}
      className={className}
    />
  ) : null;
};

export { IconSelectorField };
